import { RolePermissionModel } from './../../shared/definition/permission.model';
import { MenuModel } from './../../shared/definition/menu.model';
import { loginModel, LoginResponseModel, ReportServerLoginModel, ReportServerLoginResponseModel, ReportServerConfigResponseModel, ResetPasswordModel, ActionResultModel } from './../../shared/definition';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { apiUrls } from 'shared/consts/api-urls';
import { catchError, map } from 'rxjs/operators';
import { empty } from 'rxjs';
import { SpinningService } from 'shared/services';

const apiUrl = "api/authentication";
@Injectable({
  providedIn: 'root'
})
export class AuthenticationApiService {

  constructor(
    private httpClient: HttpClient,
    private spinningService: SpinningService
  ) {

  }

  login(model: loginModel) {
    return this.spinningService.startWith(this.httpClient.post<LoginResponseModel>(`${apiUrl}/login`, model));
  }

  logout() {

  }

  getReportConfig() {
    return this.httpClient.get<ReportServerConfigResponseModel>(`api/Report/ReportConfig`);
  }

  reportServerLogin(model: ReportServerLoginModel) {
    let params = '';
    Object.keys(model).forEach(key =>
      params += (params.length > 0 ? '&' : '') + `${key}=${model[key]}`
    );
    return this.httpClient.jsonp(`${localStorage.getItem('reportServerBaseUrl')}/login/cross/domain?${params}`,
      'callback')
      .pipe(
        map(data => data as ReportServerLoginResponseModel),
        catchError((error) => {
          console.error('登录报表服务失败,ex=', error);
          return empty();
        })
      );
  }

  getTreeList() {
    return this.httpClient.get<MenuModel[]>(`api/menu/getTreeList`);
  }

  getFirstMenu(userid: string) {
    return this.httpClient.get<MenuModel>(`api/rolepermission/${userid}/firstmenu`);
  }

  getUserPermissionList(userid: string) {
    return this.httpClient.get<string[]>(`api/rolepermission/${userid}/userpermissions`);
  }

  createVerificationCode() {
    return this.httpClient.post<string>(`${apiUrl}/verification-code`, undefined);
  }

  verifyImageCode(fileName: string, code: string) {
    return this.httpClient.get<boolean>(`${apiUrl}/verification-code/verify`, { params: { fileName, code } })
  }

  sendForgotPasswordMail(mail: string) {
    return this.spinningService.startWith(this.httpClient.post(`${apiUrl}/forgot-password-mail`, undefined, { params: { mail } }));
  }

  verifyMailCode(model: { mail: string, code: string, mailCode: string }) {
    return this.httpClient.post<ActionResultModel>(`${apiUrl}/forgot-password-mail/verify`, model);
  }



  verifyCode(code: string, telNo: string) {
    var model = { code: code, telNo: telNo };
    return this.httpClient.post<any>(`${apiUrl}/VerifyCode`, model);
  }

  sendPhoneCode(code: string, telNo: string) {
    var model = { code: code, telNo: telNo };
    return this.httpClient.post<any>(`${apiUrl}/SendPhoneCode`, model);
  }

  verifySmsCode(smsCode: string, telNo: string) {
    var model = { smsCode: smsCode, telNo: telNo };
    return this.httpClient.post<any>(`${apiUrl}/VerifySmsCode`, model);
  }

  resetPassword(model: { mail: string, code: string, password: string }) {
    return this.spinningService.startWith(this.httpClient.post<any>(`${apiUrl}/reset-password`, model));
  }

}
